<template>
  <Screen>
    <AppBar title="Package details" :showBackButton="false" />
    <Breadcrumbs title="Package details" />

    <div class="row">
      <div class="col-lg-6">
        <div class="card card-body">
          <form action="" method="post" @submit.prevent="submit" v-if="formSet">
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              type="textarea"
              name="description"
              v-model="form.description"
              :disabled="form.processing"
              :error="form.errors.description"
            />
            <TextBox
              name="old_price"
              v-model="form.old_price"
              :disabled="form.processing"
              :error="form.errors.old_price"
            />
            <TextBox
              name="price"
              v-model="form.price"
              :disabled="form.processing"
              :error="form.errors.price"
            />
            <FileInput
              name="image"
              v-model="form.image"
              :fileUrl="formData.image_url"
              :disabled="form.processing"
              :error="form.errors.image"
            />
            <hr />
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <h3 class="mb-0">Benifits</h3>
              <button
                class="btn btn-light btn-sm"
                type="button"
                @click.prevent="form.benifits.push('')"
              >
                &nbsp;Add&nbsp;
              </button>
            </div>
            <hr />
            <ol>
              <li v-for="(benifit, i) in form.benifits" :key="i">
                <div class="d-flex align-items-baseline" style="gap: 0.5rem">
                  <TextBox
                    style="flex: 1"
                    name="benifits[]"
                    label=""
                    v-model="form.benifits[i]"
                    :disabled="form.processing"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    v-tooltip="'Remove'"
                    @click.prevent="form.benifits.splice(i, 1)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </li>
            </ol>
            <div class="mt-4 text-center">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing || !hasChanges"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import _ from "lodash";

import FileInput from "@/components/form/fileInput.vue";

export default {
  components: {
    FileInput,
  },
  props: {
    formData: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      formSet: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.form.image = null;
      this.form.benifits =
        this.formData.benifits && this.formData.benifits.length
          ? [...this.formData.benifits]
          : [""];
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.$route("admin.packagedetails.update"));
    },
  },
  computed: {
    hasChanges() {
      const ogData = JSON.parse(JSON.stringify(this.formData));
      ogData.image = null;

      let hasChange = false;

      // @type Object
      let form = this.form.data();

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          const element = form[key];

          if (Array.isArray(element)) {
            // convert array to string
            if (element.join(",") !== ogData[key].join(",")) {
              hasChange = true;
              break;
            }
          } else {
            if (element !== ogData[key]) {
              hasChange = true;
              break;
            }
          }
        }
      }

      return hasChange;
    },
  },
};
</script>